export interface Category {
  key: string;
  label: string;
  desc: string;
  icon: string;
  color: string;
}

export interface HotItem {
  id: string;
  rank: number;
  cat: string;
  title: string;
  heat: number;
  trend: string;
  tag: string;
  summary: string;
  update: string;
}

export interface TimelineNode {
  time: string;
  title: string;
  desc: string;
}

export interface Archive {
  id: string;
  cat: string;
  title: string;
  lead: string;
  duration: string;
  status: string;
  imgSeq: string;
  tags: string[];
  timeline: TimelineNode[];
}

export interface LatestNews {
  id: string;
  cat: string;
  title: string;
  time: string;
  views: string;
}

export const categories: Category[] = [
  { key: "all", label: "全部档案", desc: "全站事件梳理", icon: "ri-grid-fill", color: "primary" },
  { key: "star", label: "娱乐圈", desc: "影视·综艺·舞台", icon: "ri-vip-crown-line", color: "primary" },
  { key: "internet", label: "网络热点", desc: "平台·社区·舆论", icon: "ri-fire-line", color: "accent" },
  { key: "business", label: "商业圈", desc: "公司·行业·商业", icon: "ri-briefcase-line", color: "secondary" },
  { key: "society", label: "社会议题", desc: "民生·公共话题", icon: "ri-earth-line", color: "primary" },
];

export const hotItems: HotItem[] = [
  { id: "h1", rank: 1, cat: "娱乐圈", title: "某档沉浸式综艺口碑反转始末，导演亲述剪辑争议", heat: 987200, trend: "up", tag: "综艺", summary: "一档主打沉浸式体验的综艺首播即爆，却因一段剪辑被网友反复考古，幕后团队首次回应，热度持续发酵。", update: "8分钟前" },
  { id: "h2", rank: 2, cat: "网络热点", title: "素人走红三个月后：流量反噬与直播翻车全记录", heat: 842600, trend: "up", tag: "直播", summary: "一位因一段地铁视频走红的素人主播，从爆火到被挖旧料、再到直播言论翻车，事件节点一一梳理。", update: "21分钟前" },
  { id: "h3", rank: 3, cat: "商业圈", title: "新消费咖啡品牌联名纠纷时间线：从预告到道歉", heat: 771900, trend: "flat", tag: "商业", summary: "一款新消费咖啡与艺术IP的联名合作引发抄袭争议，官方两度发声，合作方与消费者的反应全记录。", update: "35分钟前" },
  { id: "h4", rank: 4, cat: "社会议题", title: "县域夜市改造风波：商户、管理方与游客的三方视角", heat: 693400, trend: "down", tag: "民生", summary: "一条爆火短视频让县城老夜市站上风口浪尖，改造是否失去烟火气的争论持续至今。", update: "52分钟前" },
  { id: "h5", rank: 5, cat: "娱乐圈", title: "老牌乐队巡演加场争议：粉丝团购与黄牛博弈复盘", heat: 602300, trend: "up", tag: "演唱会", summary: "人气乐队开启巡演，放票机制引发粉丝不满，主办方、票务平台与乐迷各执一词。", update: "1小时前" },
  { id: "h6", rank: 6, cat: "网络热点", title: "短视频平台'注水挑战'翻红，多方下场科普的来龙去脉", heat: 554100, trend: "flat", tag: "短视频", summary: "一个充满争议的线下挑战在网络二度翻红，官方、医生与博主先后发声，节奏一波三折。", update: "2小时前" },
  { id: "h7", rank: 7, cat: "商业圈", title: "网红烘焙店排队营销失效后的转型路径梳理", heat: 486700, trend: "down", tag: "消费", summary: "曾一店难求的网红烘焙，排队营销降温后面临转型，创始人与加盟商的矛盾逐步浮出。", update: "3小时前" },
  { id: "h8", rank: 8, cat: "社会议题", title: "社区团购菜篮子补贴争议的时间线全记录", heat: 431200, trend: "up", tag: "民生", summary: "社区团购平台进入老城区，传统菜市场经营户联合发声，补贴政策是否公平引发大讨论。", update: "4小时前" },
];

export const archives: Archive[] = [
  {
    id: "a1",
    cat: "娱乐圈",
    title: "沉浸式综艺《追光之旅》口碑反转始末",
    lead: "一档开播即封神的沉浸式综艺，为何会在三个月后遭遇口碑滑铁卢？从评分、剪辑到导演回应，我们还原整条时间线。",
    duration: "全程 62 天",
    status: "热度持续",
    imgSeq: "star-tv-01",
    tags: ["综艺", "口碑", "剪辑"],
    timeline: [
      { time: "第1天", title: "预告片出圈", desc: "一段运镜流畅、氛围拉满的先导片在社交平台刷屏，播放量 24 小时破千万，观众期待值被拉满。" },
      { time: "第9天", title: "首播即封神", desc: "第一期播出后评分冲上高位，沉浸式长镜头与嘉宾互动获广泛好评，被誉为本季黑马。" },
      { time: "第31天", title: "剪辑疑云浮现", desc: "有观众逐帧对比发现疑似'恶意剪辑'痕迹，一条被删减的片段在论坛被反复讨论。" },
      { time: "第44天", title: "争议全面发酵", desc: "相关话题登上热搜，网友开始考古早期物料，导演个人账号评论区迅速沦陷。" },
      { time: "第58天", title: "导演首次回应", desc: "导演发布长文，解释剪辑逻辑并致歉，但措辞再次引发新一轮讨论，口碑进一步分化。" },
      { time: "第62天", title: "评分企稳回升", desc: "随着导演长文与后续几期播出，舆论逐渐降温，评分在小幅波动后缓慢回升。" },
    ],
  },
  {
    id: "a2",
    cat: "网络热点",
    title: "素人主播'小鹿不紧张'走红与反噬全记录",
    lead: "从地铁视频意外爆火，到旧料被挖、直播言论翻车，一位普通女孩的三个月流量过山车，是当代网红的缩影。",
    duration: "全程 87 天",
    status: "已降温",
    imgSeq: "net-live-02",
    tags: ["直播", "素人走红", "流量"],
    timeline: [
      { time: "第1天", title: "地铁偶遇视频爆火", desc: "一段记录她在地铁唱歌的十几秒视频被转发，评论区一片'治愈系'好评，账号一夜涨粉。" },
      { time: "第15天", title: "首场直播人气飙升", desc: "首场直播同时在线人数破十万，粉丝送礼不断，平台主动给予流量扶持与推荐位。" },
      { time: "第38天", title: "旧照与旧帖被挖出", desc: "部分网友晒出她几年前的学生时期帖子，质疑人设包装，'假素人'论调开始流传。" },
      { time: "第51天", title: "签约机构传闻", desc: "有自称业内人士爆料她已签约MCN机构，团队与个人账号运营边界引发讨论。" },
      { time: "第67天", title: "直播言论翻车", desc: "一次直播中对弹幕口无遮拦的回应被录屏传播，舆论风向彻底逆转，掉粉明显。" },
      { time: "第87天", title: "停播冷静期", desc: "宣布暂停直播一周复盘，发布道歉视频，热度逐渐回落，粉丝阵营持续分化。" },
    ],
  },
  {
    id: "a3",
    cat: "商业圈",
    title: "新消费咖啡'半刻'联名抄袭争议复盘",
    lead: "从一张海报预告到全网声讨，再到两次官方发声，一家新消费咖啡与独立插画师的版权之争，给行业上了一课。",
    duration: "全程 21 天",
    status: "已和解",
    imgSeq: "bus-coffee-03",
    tags: ["联名", "抄袭", "版权"],
    timeline: [
      { time: "第1天", title: "联名预告发布", desc: "'半刻'咖啡官宣与某艺术IP联名，公布概念海报，色彩与构图获好评。" },
      { time: "第5天", title: "独立插画师发声", desc: "一位独立插画师晒出自己半年前的草图，指出海报构图高度雷同，配文'似曾相识'。" },
      { time: "第8天", title: "网友对比帖刷屏", desc: "对比图在社交平台疯传，'抄袭石锤'标签冲上热搜，讨论从构图延伸到品牌审美。" },
      { time: "第12天", title: "品牌第一次回应", desc: "官方发布声明称'灵感源自合作方素材库'，措辞被指避重就轻，舆论进一步升温。" },
      { time: "第17天", title: "合作方紧急切割", desc: "艺术IP方声明与该插画师无任何关联，双方律师函你来我往，事件进入法律层面。" },
      { time: "第21天", title: "公开致歉与下架", desc: "'半刻'咖啡发布最终声明，承认沟通疏漏、下架相关产品并向插画师致歉，双方达成和解。" },
    ],
  },
  {
    id: "a4",
    cat: "社会议题",
    title: "县城老街夜市改造风波三方视角",
    lead: "一条'再不去就晚了'的短视频，让北方一座小县城的老街夜市爆红，也把改造是否过度的争论摆上台面。",
    duration: "全程 45 天",
    status: "多方博弈",
    imgSeq: "soc-market-04",
    tags: ["民生", "烟火气", "改造"],
    timeline: [
      { time: "第1天", title: "打卡视频走红", desc: "旅游博主拍摄的老街夜市夜景视频爆火，评论区一边倒称赞'烟火气回归'。" },
      { time: "第11天", title: "经营户集体发声", desc: "多位老经营户反映改造后租金上涨、摊位被调整，联名向管理方提出诉求。" },
      { time: "第20天", title: "管理方回应改造初衷", desc: "街道办回应称改造旨在提升安全与卫生，并公布新一期规划，但未正面回应租金问题。" },
      { time: "第29天", title: "游客视角加入", desc: "有游客吐槽排队体验与物价，'变味了'与'该升级了'两种声音在网络激烈碰撞。" },
      { time: "第38天", title: "官方开通意见通道", desc: "当地政府宣布开设意见征集通道，就摊位规划与租金方案公开征求意见。" },
      { time: "第45天", title: "多方协商推进", desc: "管理方、经营户与市民代表举行座谈会，初步达成'保留老档口+引入新业态'的过渡方案。" },
    ],
  },
  {
    id: "a5",
    cat: "娱乐圈",
    title: "老牌乐队'江畔'巡演放票风波复盘",
    lead: "一场被寄予厚望的全国巡演，因放票机制与加场决定引发粉丝不满，主办方两次道歉仍难平息。",
    duration: "全程 33 天",
    status: "已降温",
    imgSeq: "star-tour-05",
    tags: ["演唱会", "放票", "黄牛"],
    timeline: [
      { time: "第1天", title: "巡演官宣", desc: "老牌乐队'江畔'时隔四年宣布全国巡演，歌单与城市公布，粉丝期待值拉满。" },
      { time: "第7天", title: "首轮开票秒空", desc: "首轮门票开售后秒空，大量乐迷抢票失败，二手平台随即出现高价转售。" },
      { time: "第15天", title: "团购内幕被曝", desc: "有粉丝站晒出疑似团购渠道截图，质疑主办方'留票给黄牛'，事件迅速扩散。" },
      { time: "第22天", title: "主办方首次道歉", desc: "主办方承认票务环节存在疏漏，宣布加开一场并延长购票时间。" },
      { time: "第29天", title: "加场争议再起", desc: "加场地点被指交通不便，且开票仍秒空，乐迷不满情绪二次爆发。" },
      { time: "第33天", title: "实名制承诺", desc: "主办方承诺剩余场次推行强实名制与转赠限制，风波逐渐平息。" },
    ],
  },
  {
    id: "a6",
    cat: "网络热点",
    title: "短视频'注水挑战'二次翻红的来龙去脉",
    lead: "一个源自海外、充满争议的线下挑战，为何在国内短视频平台二次翻红？科普声浪与模仿热潮并存。",
    duration: "全程 28 天",
    status: "热度持续",
    imgSeq: "net-challenge-06",
    tags: ["短视频", "挑战", "科普"],
    timeline: [
      { time: "第1天", title: "海外原片引入", desc: "一段海外博主挑战视频被搬运，猎奇内容迅速引发围观与搬运二创。" },
      { time: "第6天", title: "国内模仿潮起", desc: "多位头部主播跟风挑战，相关标签播放量暴涨，'你挑战了吗'成流行梗。" },
      { time: "第12天", title: "安全隐患被指出", desc: "医生与科普博主陆续发声，指出该挑战存在健康风险，呼吁不要盲目模仿。" },
      { time: "第18天", title: "平台出手限流", desc: "短视频平台对相关高风险内容打上提示标签并进行限流，部分跟风视频下架。" },
      { time: "第23天", title: "官方账号下场科普", desc: "多个官方机构账号发布权威科普，结合真实案例讲解风险，传播量再创新高。" },
      { time: "第28天", title: "热潮理性降温", desc: "在多方科普下，盲目模仿减少，话题讨论转向'娱乐需有边界'。" },
    ],
  },
];

export const latestNews: LatestNews[] = [
  { id: "l1", cat: "网络热点", title: "'猫塑'新热梗走红，编辑部盘点它到底从哪来", time: "10分钟前", views: "12.4万" },
  { id: "l2", cat: "娱乐圈", title: "新剧开机被偶遇？别急，我们帮你捋清时间线", time: "28分钟前", views: "9.1万" },
  { id: "l3", cat: "商业圈", title: "国货美妆联名翻车复盘：从官宣到致歉不到一周", time: "46分钟前", views: "7.8万" },
  { id: "l4", cat: "社会议题", title: "老旧小区加装电梯争议再起，矛盾焦点在哪", time: "1小时前", views: "6.3万" },
  { id: "l5", cat: "娱乐圈", title: "电竞选手转会传闻全梳理，粉丝站连夜整理证据", time: "2小时前", views: "5.5万" },
  { id: "l6", cat: "网络热点", title: "摆拍视频到底怎么分辨？三个细节教你快速识别", time: "3小时前", views: "4.9万" },
];